<div class="work-in-progress-container">
  <div class="custom-card">
    <div class="icon-circle-wrapper">
      <div class="outer-circle">
        <div class="inner-circle">
          <i class="pi pi-exclamation-triangle icon-inside"></i>
        </div>
      </div>
    </div>
    <h1 class="card-title">Application is under review.</h1>
    <p class="card-subtitle">We are reviewing your business details. Come back to this space 1-2 days to check the
      status.</p>
    <!-- <div class="card-footer">
      <button class="logout-button" (click)="logout()">Logout</button>
    </div> -->
  </div>
</div>